<template>
    <div>
        <loading :active='isLoading' :is-full-page="fullPage" :loader='loader' />
        <div class="form-body without-side">
            <div class="img-holder">
                <div class="info-holder">
                    <img src="../../assets/images/graphic3.svg" alt="">
                </div>
            </div>
            <div class="form-holder mt-5">
                <div class="form-content">
                    <div class="form-items shadow">
                        <div class="website-logo">
                            <router-link to="/">
                                <div class="logo">
                                    <img class="logo-size" v-bind:src="imageLogoPath + data.slider_background" alt="">
                                </div>
                            </router-link>
                        </div>
                        <h3>Password Recovery</h3>
                        <form @submit.prevent="accountReset()">
                            <input class="form-control" type="text" name="email" v-model="userEmail" placeholder="E-mail Address" required>
                            <div class="form-button">
                                <button id="submit" type="submit" class="ibtn">Reset Password</button>
                            </div>
                        </form>
                        <div class="page-links">
                            <router-link to="/login">Back To Login</router-link >
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Loading from "vue-loading-overlay";
    export default {
        name: "ResetPassword",
        components: {
            Loading
        },
        data() {
            return {
                isLoading: false,
                fullPage: true,
                loader: "bars",
                accountResetURL: "api/recover-account",
                userEmail: "",
                data: [],
                imagePath: this.$api + "upload/header_logo/",
                imageLogoPath: this.$api + "upload/slider_background/"
            }
        },
        created() {
            document.title = 'Geek Buy Back - Reset Password';
            this.getHeaderData();
        },
        methods:{
            getHeaderData: function() {
                this.isLoading = true;
                var config = {
                    method: "GET",
                    url: this.$api + "api/geek-site"
                };
                this.$axios(config).then((response) => {
                    if(response.data.status == "success") {
                        this.data = response.data.data;
                    }
                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                    this.isLoading = false;
                });
            },
            showMessage: function(typeMessage, title, detailMessage) {
                this.$swal.fire(
                    title,
                    detailMessage,
                    typeMessage
                );
                return false;
            },
            checkFieldValidation: function(fieldName) {
                if(typeof(fieldName) != 'undefined') {
                    if(fieldName == null) {
                        return true;
                    }
                    else if(fieldName.length == 0) {
                        return true;
                    }
                    else {
                        return false;
                    }
                }
                else {
                    return true;
                }
            },
            accountReset: function() {
                console.log(this.userEmail);
                this.isLoading = true;
                // let errorFlag = false;
                // let errorMessage = '';
                // if(this.checkFieldValidation(this.userEmail) == true)
                // {
                //     errorFlag = true;
                //     errorMessage += "Please enter your email";
                // }

                // if(errorFlag ==  true)
                // {
                //     this.isLoading = true;
                //     this.showMessage('error', 'Validation Failed', errorMessage);
                //     return false;
                // }

                const formData = new FormData();
                formData.append('userEmail', this.userEmail);

                this.$axios.post(this.$api + this.accountResetURL, { userEmail: this.userEmail }, {
                   headers: {
                       "Access-Control-Allow-Origin": "*",
                        "Access-Control-Allow-Methods": "*",
                        "Access-Control-Allow-Headers": "*"
                   }     
                }).then(response => {
                    let row = response.data;
                    this.isLoading = false;
                    if(row.status == 0) {
                        this.showMessage('error', 'Unable to recover account', row.message);
                        return false;
                    }
                    else if(row.status == 1) {
                        this.formData.userEmail = "";
                        let userLogged = "Recovery Email Sent";
                        this.showMessage('success', userLogged, row.message);
                        return false;
                    }
                })
                .catch(e => {
                    this.isLoading = false;
                    console.log(e);
                });
            },
        }
    }
</script>